import { checkDate } from '@/scripts/validation'

export const getIsoDate = date => {
  if (date && checkDate(date)) {
    return date.replace(/(\d{2}).(\d{2}).(\d{4})/, '$3-$2-$1')
  }
}

export const getFormatDate = date => {
  if (date) {
    return date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3-$2-$1')
  }
}

export const getFormatText = date => {
  if (date) {
    return date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1')
  }
}

export const getFormatDTOText = date => {
  if (date) {
    return date.replace(/\-/g, '.')
  }
}

export const getReverseDate = date => {
  if (date) {
    return date.split('-').reverse().join('-')
  }
}